const mapperLanguageToApi = (form, user_id) => {
    const { language, proficiency, other_languages } = form

    return {
        language: language && language.value ? language.value : null,
        proficiency:
            proficiency && proficiency.value ? proficiency.value : null,
        other_languages,
        user_id: user_id,
    }
}

export { mapperLanguageToApi }
